import { render } from "./ReleasePendingPage.vue?vue&type=template&id=06d6cf90"
import script from "./ReleasePendingPage.vue?vue&type=script&lang=js"
export * from "./ReleasePendingPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__